<template>
  <div class="absolute inset-0 flex items-center justify-center">
    <slot />
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "Centered",
});
</script>
